// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Header_header__u0eQx {
    position: fixed;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    z-index: 1000;
    top: 0;
    padding: 0 32px;
    left: 0;
    box-sizing: border-box;
}
.Header_headerContainer__tA3sl{
    background-color: var(--color-header);
    color: var(--color-text-primary);
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
    max-width: 1200px;
    margin: 0 auto;
    
    border-radius: var(--border-radius-lg);
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    margin-top: 15px;
    padding: 15px 30px;
    box-sizing: border-box;
    width: 100%;
}
.Header_container__xamcs {
    max-width: 1110px;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.Header_side_block__cZ663{
    display: flex;
    align-items: center;
}
.Header_contact_block__3ndVb{
    display: flex;
    gap: 20px;
    align-items: center;
}

.Header_contact_block__3ndVb div {
    font-size: var(--font-size-md);
}

.Header_info_block__SOVVw {
    font-size: var(--font-size-sm);
    color: var(--color-primary);
    max-width: 400px;
    text-align: right;
}

.Header_socialLink__TpMnF {
    margin-left: 10px;
    display: inline-flex;
    gap: 10px;
    align-items: center;
    justify-content: center;
    transition: transform 0.2s ease;
}

.Header_socialLink__TpMnF svg {
    transition: all 0.3s ease;
}

.Header_socialLink__TpMnF:hover {
    transform: scale(1.1);
}

/* Специальные классы для изменения цвета иконок */
.Header_telegramLink__I5GB0:hover svg path {
    fill: #229ED9; /* Цвет Telegram */
}

.Header_whatsappLink__oDoWr:hover svg path {
    fill: #25D366; /* Цвет WhatsApp */
}

.Header_logo__OV\\+LA {
    display: flex;
    align-items: center;
    margin-right: 30px;
    font-size: 24px;
    font-weight: bold;
    height: 77px;
    width: auto;
    transition: transform 0.2s ease-in-out, opacity 0.2s ease;
}

.Header_logo__OV\\+LA:hover {
    transform: scale(1.05);
    opacity: 0.9;
}

.Header_logo__OV\\+LA img {
    height: 100%;
    width: auto;
}

.Header_nav_block__Ahio2 {
    display: flex;
    gap: 20px;
}

.Header_nav_item__cxPvQ {
    font-size: var(--font-size-md);
}

.Header_nav_item__cxPvQ a {
    position: relative;
    font-weight: var(--font-medium);
}

.Header_nav_item__cxPvQ a:after {
    content: '';
    position: absolute;
    width: 0;
    height: 2px;
    bottom: -5px;
    left: 0;
    background-color: var(--color-accent);
    transition: width 0.3s ease;
}

.Header_nav_item__cxPvQ a:hover:after {
    width: 100%;
}

/* Удалены стили кнопки .btn, так как они перенесены в компонент Button */

/* Стили для выпадающего меню */
.Header_dropdown__X5mRt {
    position: relative;
}

.Header_dropdown_toggle__VC24x {
    cursor: pointer;
    display: flex;
    align-items: center;
    font-weight: var(--font-medium);
    position: relative;
}

.Header_dropdown_toggle__VC24x:after {
    content: '';
    position: absolute;
    width: 0;
    height: 2px;
    bottom: -5px;
    left: 0;
    background-color: var(--color-accent);
    transition: width 0.3s ease;
}

.Header_dropdown_toggle__VC24x:hover:after {
    width: 100%;
}

.Header_dropdown_arrow__yEu7k {
    font-size: 10px;
    margin-left: 5px;
    transition: transform 0.3s;
}

.Header_dropdown__X5mRt:hover .Header_dropdown_arrow__yEu7k {
    transform: rotate(180deg);
}

.Header_dropdown_menu__h3ZV3 {
    position: absolute;
    top: 100%;
    left: 0;
    background-color: var(--color-header);
    border-radius: var(--border-radius-md);
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
    min-width: 220px;
    padding: 10px 0;
    margin-top: 10px;
    opacity: 0;
    visibility: hidden;
    transform: translateY(-10px);
    transition: opacity 0.3s, visibility 0.3s, transform 0.3s;
    z-index: 1001;
}

/* Отображение меню */
.Header_dropdown_toggle__VC24x:hover .Header_dropdown_menu__h3ZV3,
.Header_dropdown_menu__h3ZV3:hover {
    opacity: 1;
    visibility: visible;
    transform: translateY(0);
}

.Header_dropdown_item__lQyOU {
    display: block;
    padding: 10px 15px;
    color: var(--color-text-primary);
    font-size: var(--font-size-sm);
    text-decoration: none;
    transition: background-color 0.2s;
}

.Header_dropdown_item__lQyOU:hover {
    background-color: rgba(255, 255, 255, 0.1);
}

/* Фиксим отображение выпадающего меню */
.Header_dropdown_menu__h3ZV3 {
    opacity: 1;
    visibility: visible;
    transform: translateY(0);
}

/* Стили для бургера и мобильного меню */

/* Кнопка бургер-меню */
.Header_burgerButton__9oqKq {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 30px;
  height: 24px;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  z-index: 1010;
  position: relative;
}

/* Линии бургер-меню */
.Header_burgerLine__Ofnu3 {
  width: 100%;
  height: 3px;
  background-color: var(--color-text-primary);
  transition: all 0.3s ease;
  border-radius: 2px;
}

/* Анимация для активного состояния бургера */
.Header_burgerLine__Ofnu3.Header_active__N8WNj:nth-child(1) {
  transform: translateY(10.5px) rotate(45deg);
}

.Header_burgerLine__Ofnu3.Header_active__N8WNj:nth-child(2) {
  opacity: 0;
}

.Header_burgerLine__Ofnu3.Header_active__N8WNj:nth-child(3) {
  transform: translateY(-10.5px) rotate(-45deg);
}

/* Мобильное меню */
.Header_mobileMenu__wpHsJ {
  position: fixed;
  top: 120px;
  left: 32px;
  right: 32px;
  background-color: var(--color-header);
  border-radius: var(--border-radius-md);
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);
  z-index: 1000;
  padding: 20px;
  max-height: calc(100vh - 150px);
  overflow-y: auto;
  
  /* Базовые стили для анимации */
  opacity: 0;
  visibility: hidden;
  transform: translateY(-20px);
  transition: opacity 0.3s ease, visibility 0.3s ease, transform 0.3s ease;
}

/* Класс для открытого меню */
.Header_mobileMenuOpen__RsreK {
  opacity: 1;
  visibility: visible;
  transform: translateY(0);
}

/* Навигация в мобильном меню */
.Header_mobileNav__7CsEQ {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

/* Элементы мобильной навигации */
.Header_mobileNavItem__rC09F {
  padding: 10px 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.Header_mobileNavItem__rC09F:last-child {
  border-bottom: none;
}

.Header_mobileNavItem__rC09F a {
  color: var(--color-text-primary);
  text-decoration: none;
  font-size: var(--font-size-lg);
  font-weight: var(--font-medium);
  display: block;
  transition: color 0.2s ease;
}

.Header_mobileNavItem__rC09F a:hover {
  color: var(--color-accent);
}

/* Блок с контактами в мобильном меню */
.Header_mobileContactBlock__-QYHc {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

/* Телефон в мобильном меню */
.Header_mobilePhone__aG3iF {
  font-size: var(--font-size-md);
  font-weight: var(--font-medium);
  color: var(--color-text-primary);
}

/* Рабочие часы в мобильном меню */
.Header_mobileWorkingHours__cPcpH {
  font-size: var(--font-size-sm);
  color: var(--color-text-secondary, #ebebeb);
}

/* Социальные иконки в мобильном меню */
.Header_mobileSocials__3NSxw {
  display: flex;
  justify-content: center;
  gap: 20px;
  margin: 10px 0;
}

.Header_mobileSocials__3NSxw a {
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.2s ease;
}

.Header_mobileSocials__3NSxw a:hover {
  transform: scale(1.1);
}

/* Дополнительная информация в мобильном меню */
.Header_mobileInfo__e\\+Xeh {
  font-size: var(--font-size-sm);
  color: var(--color-primary);
  margin-top: 10px;
  padding-top: 15px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

/* Кнопка бургер-меню */
.Header_burgerButton__9oqKq {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 30px;
  height: 24px;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  z-index: 1010;
  position: relative;
}

/* Линии бургер-меню */
.Header_burgerLine__Ofnu3 {
  width: 100%;
  height: 3px;
  background-color: var(--color-text-primary);
  transition: all 0.3s ease;
  border-radius: 2px;
}

/* Анимация для активного состояния бургера */
.Header_burgerLine__Ofnu3.Header_active__N8WNj:nth-child(1) {
  transform: translateY(10.5px) rotate(45deg);
}

.Header_burgerLine__Ofnu3.Header_active__N8WNj:nth-child(2) {
  opacity: 0;
}

.Header_burgerLine__Ofnu3.Header_active__N8WNj:nth-child(3) {
  transform: translateY(-10.5px) rotate(-45deg);
}

/* Медиа-запросы для точной настройки разных размеров экрана */
@media (max-width: 999px) {
  .Header_logo__OV\\+LA {
    height: 60px;
    margin-right: 0;
  }
  
  /* Изменение позиции мобильного меню в зависимости от высоты хедера */
  .Header_mobileMenu__wpHsJ {
    top: 160px;
  }
}

@media (min-width: 768px) and (max-width: 999px) {
  /* Специфические стили только для планшетов */
  .Header_mobileMenu__wpHsJ {
    top: 160px; /* Учитываем дополнительную высоту для блока с телефоном */
  }
}

@media (max-width: 767px) {
  .Header_headerContainer__tA3sl {
    margin-top: 8px;
    padding: 16px 16px;
  }
  
  .Header_logo__OV\\+LA {
    height: 50px;
  }
  
  /* Изменение позиции мобильного меню для телефонов */
  .Header_mobileMenu__wpHsJ {
    top: 80px;
    left: 15px;
    right: 15px;
    padding: 15px;
  }
  
  /* Уменьшенные размеры элементов для телефонов */
  .Header_mobileNavItem__rC09F a {
    font-size: var(--font-size-md);
  }
}

/* Добавляем стили для планшетной версии с телефоном и часами работы над логотипом */

/* Стили для планшетов (768px - 999px) */
.Header_tabletHeader__P\\+0kD {
  padding: 10px 20px;
  flex-direction: column;
}

/* Контейнер для контактной информации на планшете */
.Header_tabletContactContainer__Fq5Cx {
  width: 100%;
  display: flex;
  justify-content: center;
  justify-content: start;
  align-items: center;
  margin-bottom: 8px;
}

.Header_tabletContactInfo__67HWq {
  display: flex;
  /* align-items: center; */
  gap: 15px;
}

/* Телефон на планшете */
.Header_tabletPhone__MdI3K {
  font-size: var(--font-size-md);
  font-weight: var(--font-medium);
  color: var(--color-text-primary);
}

/* Часы работы на планшете */
.Header_tabletWorkingHours__QWB4m {
  font-size: var(--font-size-sm);
  color: var(--color-text-secondary, #ebebeb);
  margin-top: 2px;
}

/* Базовые стили для мобильных устройств (до 767px) */
.Header_mobileHeader__8nUID {
  padding: 10px 15px;
  margin-top: 10px;
  margin-left: 10px;
  margin-right: 10px;
}

/* Общие стили для мобильного меню */
.Header_mobileMenu__wpHsJ {
  position: fixed;
  top: 120px;
  left: 32px;
  right: 32px;
  background-color: var(--color-header);
  border-radius: var(--border-radius-md);
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);
  z-index: 1000;
  padding: 20px;
  max-height: calc(100vh - 150px);
  overflow-y: auto;
  
  /* Базовые стили для анимации */
  opacity: 0;
  visibility: hidden;
  transform: translateY(-20px);
  transition: opacity 0.3s ease, visibility 0.3s ease, transform 0.3s ease;
}

.Header_mobileMenuOpen__RsreK {
  opacity: 1;
  visibility: visible;
  transform: translateY(0);
}

/* Навигация в мобильном меню */
.Header_mobileNav__7CsEQ {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

/* Элементы мобильной навигации */
.Header_mobileNavItem__rC09F {
  padding: 10px 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.Header_mobileNavItem__rC09F:last-child {
  border-bottom: none;
}

.Header_mobileNavItem__rC09F a {
  color: var(--color-text-primary);
  text-decoration: none;
  font-size: var(--font-size-lg);
  font-weight: var(--font-medium);
  display: block;
  transition: color 0.2s ease;
}

.Header_mobileNavItem__rC09F a:hover {
  color: var(--color-accent);
}

/* Блок с контактами в мобильном меню */
.Header_mobileContactBlock__-QYHc {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

/* Телефон в мобильном меню */
.Header_mobilePhone__aG3iF {
  font-size: var(--font-size-md);
  font-weight: var(--font-medium);
  color: var(--color-text-primary);
  margin: 0;
}

/* Рабочие часы в мобильном меню */
.Header_mobileWorkingHours__cPcpH {
  font-size: var(--font-size-sm);
  color: var(--color-text-secondary, #ebebeb);
}

/* Социальные иконки в мобильном меню */
.Header_mobileSocials__3NSxw {
  display: flex;
  gap: 20px;
  margin: 10px 0;
}

.Header_mobileSocials__3NSxw a {
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.2s ease;
}

.Header_mobileSocials__3NSxw a:hover {
  transform: scale(1.1);
}

/* Дополнительная информация в мобильном меню */
.Header_mobileInfo__e\\+Xeh {
  font-size: var(--font-size-sm);
  color: var(--color-primary);
  margin-top: 10px;
  padding-top: 15px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

/* Кнопка бургер-меню */
.Header_burgerButton__9oqKq {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 30px;
  height: 24px;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  z-index: 1010;
  position: relative;
}

/* Линии бургер-меню */
.Header_burgerLine__Ofnu3 {
  width: 100%;
  height: 3px;
  background-color: var(--color-text-primary);
  transition: all 0.3s ease;
  border-radius: 2px;
}

/* Анимация для активного состояния бургера */
.Header_burgerLine__Ofnu3.Header_active__N8WNj:nth-child(1) {
  transform: translateY(10.5px) rotate(45deg);
}

.Header_burgerLine__Ofnu3.Header_active__N8WNj:nth-child(2) {
  opacity: 0;
}

.Header_burgerLine__Ofnu3.Header_active__N8WNj:nth-child(3) {
  transform: translateY(-10.5px) rotate(-45deg);
}

/* Медиа-запросы для точной настройки разных размеров экрана */
@media (max-width: 999px) {
  .Header_logo__OV\\+LA {
    height: 60px;
    margin-right: 0;
  }
  
  /* Изменение позиции мобильного меню в зависимости от высоты хедера */
  .Header_mobileMenu__wpHsJ {
    top: 100px;
  }
}

@media (min-width: 768px) and (max-width: 999px) {
  /* Специфические стили только для планшетов */
  .Header_mobileMenu__wpHsJ {
    top: 160px; /* Учитываем дополнительную высоту для блока с телефоном */
  }
}

@media (max-width: 767px) {
  .Header_header__u0eQx {
    margin-top: 8px;
    padding: 16px 16px;
    margin: 0;
  }
  
  .Header_logo__OV\\+LA {
    height: 50px;
  }
  
  /* Изменение позиции мобильного меню для телефонов */
  .Header_mobileMenu__wpHsJ {
    top: 125px;
    left: 15px;
    right: 15px;
    padding: 15px;
  }
  
  /* Уменьшенные размеры элементов для телефонов */
  .Header_mobileNavItem__rC09F a {
    font-size: var(--font-size-md);
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/EntToEndUI/Header/Header.module.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,aAAa;IACb,MAAM;IACN,eAAe;IACf,OAAO;IACP,sBAAsB;AAC1B;AACA;IACI,qCAAqC;IACrC,gCAAgC;IAChC,yCAAyC;IACzC,iBAAiB;IACjB,cAAc;;IAEd,sCAAsC;IACtC,aAAa;IACb,uBAAuB;IACvB,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,sBAAsB;IACtB,WAAW;AACf;AACA;IACI,iBAAiB;IACjB,WAAW;IACX,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,8BAA8B;IAC9B,2BAA2B;IAC3B,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,oBAAoB;IACpB,SAAS;IACT,mBAAmB;IACnB,uBAAuB;IACvB,+BAA+B;AACnC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;AACzB;;AAEA,kDAAkD;AAClD;IACI,aAAa,EAAE,kBAAkB;AACrC;;AAEA;IACI,aAAa,EAAE,kBAAkB;AACrC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,WAAW;IACX,yDAAyD;AAC7D;;AAEA;IACI,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;IAClB,+BAA+B;AACnC;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,OAAO;IACP,qCAAqC;IACrC,2BAA2B;AAC/B;;AAEA;IACI,WAAW;AACf;;AAEA,yEAAyE;;AAEzE,+BAA+B;AAC/B;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,+BAA+B;IAC/B,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,OAAO;IACP,qCAAqC;IACrC,2BAA2B;AAC/B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,qCAAqC;IACrC,sCAAsC;IACtC,yCAAyC;IACzC,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,kBAAkB;IAClB,4BAA4B;IAC5B,yDAAyD;IACzD,aAAa;AACjB;;AAEA,qBAAqB;AACrB;;IAEI,UAAU;IACV,mBAAmB;IACnB,wBAAwB;AAC5B;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,gCAAgC;IAChC,8BAA8B;IAC9B,qBAAqB;IACrB,iCAAiC;AACrC;;AAEA;IACI,0CAA0C;AAC9C;;AAEA,wCAAwC;AACxC;IACI,UAAU;IACV,mBAAmB;IACnB,wBAAwB;AAC5B;;AAEA,wCAAwC;;AAExC,uBAAuB;AACvB;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,UAAU;EACV,aAAa;EACb,kBAAkB;AACpB;;AAEA,sBAAsB;AACtB;EACE,WAAW;EACX,WAAW;EACX,2CAA2C;EAC3C,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA,6CAA6C;AAC7C;EACE,2CAA2C;AAC7C;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,6CAA6C;AAC/C;;AAEA,mBAAmB;AACnB;EACE,eAAe;EACf,UAAU;EACV,UAAU;EACV,WAAW;EACX,qCAAqC;EACrC,sCAAsC;EACtC,yCAAyC;EACzC,aAAa;EACb,aAAa;EACb,+BAA+B;EAC/B,gBAAgB;;EAEhB,+BAA+B;EAC/B,UAAU;EACV,kBAAkB;EAClB,4BAA4B;EAC5B,wEAAwE;AAC1E;;AAEA,6BAA6B;AAC7B;EACE,UAAU;EACV,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,iCAAiC;AACjC;EACE,eAAe;EACf,iDAAiD;AACnD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,qBAAqB;EACrB,8BAA8B;EAC9B,+BAA+B;EAC/B,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,uCAAuC;AACvC;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,6BAA6B;AAC7B;EACE,8BAA8B;EAC9B,+BAA+B;EAC/B,gCAAgC;AAClC;;AAEA,kCAAkC;AAClC;EACE,8BAA8B;EAC9B,2CAA2C;AAC7C;;AAEA,uCAAuC;AACvC;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;AACvB;;AAEA,+CAA+C;AAC/C;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,gBAAgB;EAChB,iBAAiB;EACjB,8CAA8C;AAChD;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,UAAU;EACV,aAAa;EACb,kBAAkB;AACpB;;AAEA,sBAAsB;AACtB;EACE,WAAW;EACX,WAAW;EACX,2CAA2C;EAC3C,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA,6CAA6C;AAC7C;EACE,2CAA2C;AAC7C;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,6CAA6C;AAC/C;;AAEA,8DAA8D;AAC9D;EACE;IACE,YAAY;IACZ,eAAe;EACjB;;EAEA,qEAAqE;EACrE;IACE,UAAU;EACZ;AACF;;AAEA;EACE,6CAA6C;EAC7C;IACE,UAAU,EAAE,0DAA0D;EACxE;AACF;;AAEA;EACE;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,YAAY;EACd;;EAEA,oDAAoD;EACpD;IACE,SAAS;IACT,UAAU;IACV,WAAW;IACX,aAAa;EACf;;EAEA,gDAAgD;EAChD;IACE,8BAA8B;EAChC;AACF;;AAEA,oFAAoF;;AAEpF,wCAAwC;AACxC;EACE,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA,oDAAoD;AACpD;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;AACX;;AAEA,wBAAwB;AACxB;EACE,8BAA8B;EAC9B,+BAA+B;EAC/B,gCAAgC;AAClC;;AAEA,4BAA4B;AAC5B;EACE,8BAA8B;EAC9B,2CAA2C;EAC3C,eAAe;AACjB;;AAEA,qDAAqD;AACrD;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,oCAAoC;AACpC;EACE,eAAe;EACf,UAAU;EACV,UAAU;EACV,WAAW;EACX,qCAAqC;EACrC,sCAAsC;EACtC,yCAAyC;EACzC,aAAa;EACb,aAAa;EACb,+BAA+B;EAC/B,gBAAgB;;EAEhB,+BAA+B;EAC/B,UAAU;EACV,kBAAkB;EAClB,4BAA4B;EAC5B,wEAAwE;AAC1E;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,iCAAiC;AACjC;EACE,eAAe;EACf,iDAAiD;AACnD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,qBAAqB;EACrB,8BAA8B;EAC9B,+BAA+B;EAC/B,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,uCAAuC;AACvC;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,6BAA6B;AAC7B;EACE,8BAA8B;EAC9B,+BAA+B;EAC/B,gCAAgC;EAChC,SAAS;AACX;;AAEA,kCAAkC;AAClC;EACE,8BAA8B;EAC9B,2CAA2C;AAC7C;;AAEA,uCAAuC;AACvC;EACE,aAAa;EACb,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;AACvB;;AAEA,+CAA+C;AAC/C;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,gBAAgB;EAChB,iBAAiB;EACjB,8CAA8C;AAChD;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,UAAU;EACV,aAAa;EACb,kBAAkB;AACpB;;AAEA,sBAAsB;AACtB;EACE,WAAW;EACX,WAAW;EACX,2CAA2C;EAC3C,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA,6CAA6C;AAC7C;EACE,2CAA2C;AAC7C;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,6CAA6C;AAC/C;;AAEA,8DAA8D;AAC9D;EACE;IACE,YAAY;IACZ,eAAe;EACjB;;EAEA,qEAAqE;EACrE;IACE,UAAU;EACZ;AACF;;AAEA;EACE,6CAA6C;EAC7C;IACE,UAAU,EAAE,0DAA0D;EACxE;AACF;;AAEA;EACE;IACE,eAAe;IACf,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,YAAY;EACd;;EAEA,oDAAoD;EACpD;IACE,UAAU;IACV,UAAU;IACV,WAAW;IACX,aAAa;EACf;;EAEA,gDAAgD;EAChD;IACE,8BAA8B;EAChC;AACF","sourcesContent":[".header {\n    position: fixed;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    z-index: 1000;\n    top: 0;\n    padding: 0 32px;\n    left: 0;\n    box-sizing: border-box;\n}\n.headerContainer{\n    background-color: var(--color-header);\n    color: var(--color-text-primary);\n    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);\n    max-width: 1200px;\n    margin: 0 auto;\n    \n    border-radius: var(--border-radius-lg);\n    display: flex;\n    justify-content: center;\n    flex-direction: column;\n    align-items: center;\n    margin-top: 15px;\n    padding: 15px 30px;\n    box-sizing: border-box;\n    width: 100%;\n}\n.container {\n    max-width: 1110px;\n    width: 100%;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n.side_block{\n    display: flex;\n    align-items: center;\n}\n.contact_block{\n    display: flex;\n    gap: 20px;\n    align-items: center;\n}\n\n.contact_block div {\n    font-size: var(--font-size-md);\n}\n\n.info_block {\n    font-size: var(--font-size-sm);\n    color: var(--color-primary);\n    max-width: 400px;\n    text-align: right;\n}\n\n.socialLink {\n    margin-left: 10px;\n    display: inline-flex;\n    gap: 10px;\n    align-items: center;\n    justify-content: center;\n    transition: transform 0.2s ease;\n}\n\n.socialLink svg {\n    transition: all 0.3s ease;\n}\n\n.socialLink:hover {\n    transform: scale(1.1);\n}\n\n/* Специальные классы для изменения цвета иконок */\n.telegramLink:hover svg path {\n    fill: #229ED9; /* Цвет Telegram */\n}\n\n.whatsappLink:hover svg path {\n    fill: #25D366; /* Цвет WhatsApp */\n}\n\n.logo {\n    display: flex;\n    align-items: center;\n    margin-right: 30px;\n    font-size: 24px;\n    font-weight: bold;\n    height: 77px;\n    width: auto;\n    transition: transform 0.2s ease-in-out, opacity 0.2s ease;\n}\n\n.logo:hover {\n    transform: scale(1.05);\n    opacity: 0.9;\n}\n\n.logo img {\n    height: 100%;\n    width: auto;\n}\n\n.nav_block {\n    display: flex;\n    gap: 20px;\n}\n\n.nav_item {\n    font-size: var(--font-size-md);\n}\n\n.nav_item a {\n    position: relative;\n    font-weight: var(--font-medium);\n}\n\n.nav_item a:after {\n    content: '';\n    position: absolute;\n    width: 0;\n    height: 2px;\n    bottom: -5px;\n    left: 0;\n    background-color: var(--color-accent);\n    transition: width 0.3s ease;\n}\n\n.nav_item a:hover:after {\n    width: 100%;\n}\n\n/* Удалены стили кнопки .btn, так как они перенесены в компонент Button */\n\n/* Стили для выпадающего меню */\n.dropdown {\n    position: relative;\n}\n\n.dropdown_toggle {\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    font-weight: var(--font-medium);\n    position: relative;\n}\n\n.dropdown_toggle:after {\n    content: '';\n    position: absolute;\n    width: 0;\n    height: 2px;\n    bottom: -5px;\n    left: 0;\n    background-color: var(--color-accent);\n    transition: width 0.3s ease;\n}\n\n.dropdown_toggle:hover:after {\n    width: 100%;\n}\n\n.dropdown_arrow {\n    font-size: 10px;\n    margin-left: 5px;\n    transition: transform 0.3s;\n}\n\n.dropdown:hover .dropdown_arrow {\n    transform: rotate(180deg);\n}\n\n.dropdown_menu {\n    position: absolute;\n    top: 100%;\n    left: 0;\n    background-color: var(--color-header);\n    border-radius: var(--border-radius-md);\n    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);\n    min-width: 220px;\n    padding: 10px 0;\n    margin-top: 10px;\n    opacity: 0;\n    visibility: hidden;\n    transform: translateY(-10px);\n    transition: opacity 0.3s, visibility 0.3s, transform 0.3s;\n    z-index: 1001;\n}\n\n/* Отображение меню */\n.dropdown_toggle:hover .dropdown_menu,\n.dropdown_menu:hover {\n    opacity: 1;\n    visibility: visible;\n    transform: translateY(0);\n}\n\n.dropdown_item {\n    display: block;\n    padding: 10px 15px;\n    color: var(--color-text-primary);\n    font-size: var(--font-size-sm);\n    text-decoration: none;\n    transition: background-color 0.2s;\n}\n\n.dropdown_item:hover {\n    background-color: rgba(255, 255, 255, 0.1);\n}\n\n/* Фиксим отображение выпадающего меню */\n.dropdown_menu {\n    opacity: 1;\n    visibility: visible;\n    transform: translateY(0);\n}\n\n/* Стили для бургера и мобильного меню */\n\n/* Кнопка бургер-меню */\n.burgerButton {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  width: 30px;\n  height: 24px;\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  padding: 0;\n  z-index: 1010;\n  position: relative;\n}\n\n/* Линии бургер-меню */\n.burgerLine {\n  width: 100%;\n  height: 3px;\n  background-color: var(--color-text-primary);\n  transition: all 0.3s ease;\n  border-radius: 2px;\n}\n\n/* Анимация для активного состояния бургера */\n.burgerLine.active:nth-child(1) {\n  transform: translateY(10.5px) rotate(45deg);\n}\n\n.burgerLine.active:nth-child(2) {\n  opacity: 0;\n}\n\n.burgerLine.active:nth-child(3) {\n  transform: translateY(-10.5px) rotate(-45deg);\n}\n\n/* Мобильное меню */\n.mobileMenu {\n  position: fixed;\n  top: 120px;\n  left: 32px;\n  right: 32px;\n  background-color: var(--color-header);\n  border-radius: var(--border-radius-md);\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);\n  z-index: 1000;\n  padding: 20px;\n  max-height: calc(100vh - 150px);\n  overflow-y: auto;\n  \n  /* Базовые стили для анимации */\n  opacity: 0;\n  visibility: hidden;\n  transform: translateY(-20px);\n  transition: opacity 0.3s ease, visibility 0.3s ease, transform 0.3s ease;\n}\n\n/* Класс для открытого меню */\n.mobileMenuOpen {\n  opacity: 1;\n  visibility: visible;\n  transform: translateY(0);\n}\n\n/* Навигация в мобильном меню */\n.mobileNav {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n/* Элементы мобильной навигации */\n.mobileNavItem {\n  padding: 10px 0;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.mobileNavItem:last-child {\n  border-bottom: none;\n}\n\n.mobileNavItem a {\n  color: var(--color-text-primary);\n  text-decoration: none;\n  font-size: var(--font-size-lg);\n  font-weight: var(--font-medium);\n  display: block;\n  transition: color 0.2s ease;\n}\n\n.mobileNavItem a:hover {\n  color: var(--color-accent);\n}\n\n/* Блок с контактами в мобильном меню */\n.mobileContactBlock {\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n}\n\n/* Телефон в мобильном меню */\n.mobilePhone {\n  font-size: var(--font-size-md);\n  font-weight: var(--font-medium);\n  color: var(--color-text-primary);\n}\n\n/* Рабочие часы в мобильном меню */\n.mobileWorkingHours {\n  font-size: var(--font-size-sm);\n  color: var(--color-text-secondary, #ebebeb);\n}\n\n/* Социальные иконки в мобильном меню */\n.mobileSocials {\n  display: flex;\n  justify-content: center;\n  gap: 20px;\n  margin: 10px 0;\n}\n\n.mobileSocials a {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: transform 0.2s ease;\n}\n\n.mobileSocials a:hover {\n  transform: scale(1.1);\n}\n\n/* Дополнительная информация в мобильном меню */\n.mobileInfo {\n  font-size: var(--font-size-sm);\n  color: var(--color-primary);\n  margin-top: 10px;\n  padding-top: 15px;\n  border-top: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n/* Кнопка бургер-меню */\n.burgerButton {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  width: 30px;\n  height: 24px;\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  padding: 0;\n  z-index: 1010;\n  position: relative;\n}\n\n/* Линии бургер-меню */\n.burgerLine {\n  width: 100%;\n  height: 3px;\n  background-color: var(--color-text-primary);\n  transition: all 0.3s ease;\n  border-radius: 2px;\n}\n\n/* Анимация для активного состояния бургера */\n.burgerLine.active:nth-child(1) {\n  transform: translateY(10.5px) rotate(45deg);\n}\n\n.burgerLine.active:nth-child(2) {\n  opacity: 0;\n}\n\n.burgerLine.active:nth-child(3) {\n  transform: translateY(-10.5px) rotate(-45deg);\n}\n\n/* Медиа-запросы для точной настройки разных размеров экрана */\n@media (max-width: 999px) {\n  .logo {\n    height: 60px;\n    margin-right: 0;\n  }\n  \n  /* Изменение позиции мобильного меню в зависимости от высоты хедера */\n  .mobileMenu {\n    top: 160px;\n  }\n}\n\n@media (min-width: 768px) and (max-width: 999px) {\n  /* Специфические стили только для планшетов */\n  .mobileMenu {\n    top: 160px; /* Учитываем дополнительную высоту для блока с телефоном */\n  }\n}\n\n@media (max-width: 767px) {\n  .headerContainer {\n    margin-top: 8px;\n    padding: 16px 16px;\n  }\n  \n  .logo {\n    height: 50px;\n  }\n  \n  /* Изменение позиции мобильного меню для телефонов */\n  .mobileMenu {\n    top: 80px;\n    left: 15px;\n    right: 15px;\n    padding: 15px;\n  }\n  \n  /* Уменьшенные размеры элементов для телефонов */\n  .mobileNavItem a {\n    font-size: var(--font-size-md);\n  }\n}\n\n/* Добавляем стили для планшетной версии с телефоном и часами работы над логотипом */\n\n/* Стили для планшетов (768px - 999px) */\n.tabletHeader {\n  padding: 10px 20px;\n  flex-direction: column;\n}\n\n/* Контейнер для контактной информации на планшете */\n.tabletContactContainer {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  justify-content: start;\n  align-items: center;\n  margin-bottom: 8px;\n}\n\n.tabletContactInfo {\n  display: flex;\n  /* align-items: center; */\n  gap: 15px;\n}\n\n/* Телефон на планшете */\n.tabletPhone {\n  font-size: var(--font-size-md);\n  font-weight: var(--font-medium);\n  color: var(--color-text-primary);\n}\n\n/* Часы работы на планшете */\n.tabletWorkingHours {\n  font-size: var(--font-size-sm);\n  color: var(--color-text-secondary, #ebebeb);\n  margin-top: 2px;\n}\n\n/* Базовые стили для мобильных устройств (до 767px) */\n.mobileHeader {\n  padding: 10px 15px;\n  margin-top: 10px;\n  margin-left: 10px;\n  margin-right: 10px;\n}\n\n/* Общие стили для мобильного меню */\n.mobileMenu {\n  position: fixed;\n  top: 120px;\n  left: 32px;\n  right: 32px;\n  background-color: var(--color-header);\n  border-radius: var(--border-radius-md);\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);\n  z-index: 1000;\n  padding: 20px;\n  max-height: calc(100vh - 150px);\n  overflow-y: auto;\n  \n  /* Базовые стили для анимации */\n  opacity: 0;\n  visibility: hidden;\n  transform: translateY(-20px);\n  transition: opacity 0.3s ease, visibility 0.3s ease, transform 0.3s ease;\n}\n\n.mobileMenuOpen {\n  opacity: 1;\n  visibility: visible;\n  transform: translateY(0);\n}\n\n/* Навигация в мобильном меню */\n.mobileNav {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n/* Элементы мобильной навигации */\n.mobileNavItem {\n  padding: 10px 0;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.mobileNavItem:last-child {\n  border-bottom: none;\n}\n\n.mobileNavItem a {\n  color: var(--color-text-primary);\n  text-decoration: none;\n  font-size: var(--font-size-lg);\n  font-weight: var(--font-medium);\n  display: block;\n  transition: color 0.2s ease;\n}\n\n.mobileNavItem a:hover {\n  color: var(--color-accent);\n}\n\n/* Блок с контактами в мобильном меню */\n.mobileContactBlock {\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n}\n\n/* Телефон в мобильном меню */\n.mobilePhone {\n  font-size: var(--font-size-md);\n  font-weight: var(--font-medium);\n  color: var(--color-text-primary);\n  margin: 0;\n}\n\n/* Рабочие часы в мобильном меню */\n.mobileWorkingHours {\n  font-size: var(--font-size-sm);\n  color: var(--color-text-secondary, #ebebeb);\n}\n\n/* Социальные иконки в мобильном меню */\n.mobileSocials {\n  display: flex;\n  gap: 20px;\n  margin: 10px 0;\n}\n\n.mobileSocials a {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: transform 0.2s ease;\n}\n\n.mobileSocials a:hover {\n  transform: scale(1.1);\n}\n\n/* Дополнительная информация в мобильном меню */\n.mobileInfo {\n  font-size: var(--font-size-sm);\n  color: var(--color-primary);\n  margin-top: 10px;\n  padding-top: 15px;\n  border-top: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n/* Кнопка бургер-меню */\n.burgerButton {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  width: 30px;\n  height: 24px;\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  padding: 0;\n  z-index: 1010;\n  position: relative;\n}\n\n/* Линии бургер-меню */\n.burgerLine {\n  width: 100%;\n  height: 3px;\n  background-color: var(--color-text-primary);\n  transition: all 0.3s ease;\n  border-radius: 2px;\n}\n\n/* Анимация для активного состояния бургера */\n.burgerLine.active:nth-child(1) {\n  transform: translateY(10.5px) rotate(45deg);\n}\n\n.burgerLine.active:nth-child(2) {\n  opacity: 0;\n}\n\n.burgerLine.active:nth-child(3) {\n  transform: translateY(-10.5px) rotate(-45deg);\n}\n\n/* Медиа-запросы для точной настройки разных размеров экрана */\n@media (max-width: 999px) {\n  .logo {\n    height: 60px;\n    margin-right: 0;\n  }\n  \n  /* Изменение позиции мобильного меню в зависимости от высоты хедера */\n  .mobileMenu {\n    top: 100px;\n  }\n}\n\n@media (min-width: 768px) and (max-width: 999px) {\n  /* Специфические стили только для планшетов */\n  .mobileMenu {\n    top: 160px; /* Учитываем дополнительную высоту для блока с телефоном */\n  }\n}\n\n@media (max-width: 767px) {\n  .header {\n    margin-top: 8px;\n    padding: 16px 16px;\n    margin: 0;\n  }\n  \n  .logo {\n    height: 50px;\n  }\n  \n  /* Изменение позиции мобильного меню для телефонов */\n  .mobileMenu {\n    top: 125px;\n    left: 15px;\n    right: 15px;\n    padding: 15px;\n  }\n  \n  /* Уменьшенные размеры элементов для телефонов */\n  .mobileNavItem a {\n    font-size: var(--font-size-md);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `Header_header__u0eQx`,
	"headerContainer": `Header_headerContainer__tA3sl`,
	"container": `Header_container__xamcs`,
	"side_block": `Header_side_block__cZ663`,
	"contact_block": `Header_contact_block__3ndVb`,
	"info_block": `Header_info_block__SOVVw`,
	"socialLink": `Header_socialLink__TpMnF`,
	"telegramLink": `Header_telegramLink__I5GB0`,
	"whatsappLink": `Header_whatsappLink__oDoWr`,
	"logo": `Header_logo__OV+LA`,
	"nav_block": `Header_nav_block__Ahio2`,
	"nav_item": `Header_nav_item__cxPvQ`,
	"dropdown": `Header_dropdown__X5mRt`,
	"dropdown_toggle": `Header_dropdown_toggle__VC24x`,
	"dropdown_arrow": `Header_dropdown_arrow__yEu7k`,
	"dropdown_menu": `Header_dropdown_menu__h3ZV3`,
	"dropdown_item": `Header_dropdown_item__lQyOU`,
	"burgerButton": `Header_burgerButton__9oqKq`,
	"burgerLine": `Header_burgerLine__Ofnu3`,
	"active": `Header_active__N8WNj`,
	"mobileMenu": `Header_mobileMenu__wpHsJ`,
	"mobileMenuOpen": `Header_mobileMenuOpen__RsreK`,
	"mobileNav": `Header_mobileNav__7CsEQ`,
	"mobileNavItem": `Header_mobileNavItem__rC09F`,
	"mobileContactBlock": `Header_mobileContactBlock__-QYHc`,
	"mobilePhone": `Header_mobilePhone__aG3iF`,
	"mobileWorkingHours": `Header_mobileWorkingHours__cPcpH`,
	"mobileSocials": `Header_mobileSocials__3NSxw`,
	"mobileInfo": `Header_mobileInfo__e+Xeh`,
	"tabletHeader": `Header_tabletHeader__P+0kD`,
	"tabletContactContainer": `Header_tabletContactContainer__Fq5Cx`,
	"tabletContactInfo": `Header_tabletContactInfo__67HWq`,
	"tabletPhone": `Header_tabletPhone__MdI3K`,
	"tabletWorkingHours": `Header_tabletWorkingHours__QWB4m`,
	"mobileHeader": `Header_mobileHeader__8nUID`
};
export default ___CSS_LOADER_EXPORT___;
